type CharacterCountProps = {
  /**
   * maxLength for an input.
   */
  maxLength: number;
  /**
   * Current length of the input's value string.
   */
  currentLength: number;
  /**
   * Optionally configure the text before the count.
   */
  text?: string;
};

/**
 * Simple component for displaying the number of remaining characters
 * allowed in an input field.
 */
const CharacterCount = ({ maxLength, currentLength, text }: CharacterCountProps) => (
  <div className="fossa-form__character-count">
    {text} {currentLength}/{maxLength}
  </div>
);

export default CharacterCount;
